/** @jsxImportSource @emotion/react */

import Image from 'next/image';

import { media } from '@stories/theming/settings';
import imageLoader from '@utils/imageLoader';

import { headlines } from './VitafyAboutUsPage';

const paragraph = {
  lineHeight: '1.7',
  margin: '1rem 0',
  opacity: 0.8,
  fontWeight: '400'
} as const;

export const OurStory: React.FC = () => {
  return (
    <section css={{ background: 'linear-gradient(#045880 0%, #022C40 100%)', color: 'white' }}>
      <div
        css={{
          padding: '5rem .5rem 4rem',
          margin: 'auto',
          maxWidth: '1400px',
          [media('desktop')]: { padding: '7rem .5rem 1rem' }
        }}
      >
        <div css={{ display: 'flex', flexWrap: 'wrap', marginBottom: '3rem' }}>
          <div
            css={{
              aspectRatio: '4/3',
              position: 'relative',
              flex: '0 0 calc(100% - 1rem)',
              margin: '0 .5rem',
              order: 1,
              [media('desktop')]: { order: 0, flex: '0 0 50%', margin: 0 }
            }}
          >
            <Image
              loader={imageLoader}
              src="/c_crop,ar_1.333/vitafy/about-us/founders.png"
              sizes="(min-width: 640px) 500px, 100vw"
              alt="Vitafy founders"
              fill
            />
          </div>
          <div
            css={{
              padding: '.0 .5rem',
              flex: '0 0 100%',
              [media('desktop')]: { flex: '0 0 50%', padding: '0 .5rem 0 2rem' }
            }}
          >
            <h2 css={{ ...headlines.h3 }}>10 Jahre Erfahrung</h2>
            <p css={{ ...paragraph }}>
              Vitafy wurde vor 10 Jahren gegründet, um den Markt für Sportnahrung und Nahrungsergänzungsmittel
              zu revolutionieren.
            </p>
            <p css={{ ...paragraph }}>
              Ziel war es, eine vertrauenswürdige Plattform mit hochwertigen Produkten für Sportler und
              gesundheitsbewusste Konsumenten zu schaffen.
            </p>
          </div>
        </div>

        <div css={{ display: 'flex', flexWrap: 'wrap', [media('desktop')]: { marginTop: '5rem' } }}>
          <div
            css={{
              flex: '0 0 100%',
              padding: '0 .5rem',
              order: 1,
              [media('desktop')]: { flex: '0 0 50%' }
            }}
          >
            <div
              css={{
                aspectRatio: '16/9',
                marginBottom: '2rem',
                position: 'relative'
              }}
            >
              <Image
                loader={imageLoader}
                src="/vitafy/about-us/products.png"
                sizes="(min-width: 640px) 500px, 100vw"
                alt="Vitafy founders"
                fill
              />
            </div>
            <div
              css={{
                aspectRatio: '1',
                position: 'relative'
              }}
            >
              <Image
                loader={imageLoader}
                src="/vitafy/about-us/athletes.jpg"
                sizes="(min-width: 640px) 500px, 100vw"
                alt="Vitafy founders"
                fill
              />
            </div>
          </div>
          <div css={{ padding: '.0 .5rem', flex: '0 0 100%', [media('desktop')]: { flex: '0 0 50%' } }}>
            <h2 css={{ ...headlines.h3 }}>Unsere Mission</h2>
            <p css={{ ...paragraph, fontWeight: 'bold' }}>
              Seit nun schon 10 Jahren helfen wir unseren Kunden, ein gesünderes und fitteres Leben zu führen,
              indem wir ihnen einfachen Zugang zu hochwertigen Ernährungs- und Gesundheitsprodukten bieten.
            </p>
            <p css={{ ...paragraph }}>
              <span css={{ fontWeight: 'bold' }}>Förderung von Gesundheit und Wohlbefinden: </span> Wir bieten
              eine Vielfalt an sorgfältig ausgewählten und hochwertigen Produkten wie
              Nahrungsergänzungsmitteln, Superfoods und Sportnahrung an, um unsere Kunden bei der Umsetzung
              ihrer Ziele zu unterstützen.
            </p>
            <p css={{ ...paragraph }}>
              <span css={{ fontWeight: 'bold' }}>Transparenz und Vertrauen: </span> Wir schaffen Vertrauen
              durch ausführliche Produktbeschreibungen, detaillierte Nährwertangaben und Kundenbewertungen.
            </p>
            <p css={{ ...paragraph }}>
              <span css={{ fontWeight: 'bold' }}>Sicherheit: </span> Uns ist es wichtig, eine Plattform zu
              schaffen, die nicht nur wirtschaftlich erfolgreich ist, sondern auch Sicherheit garantiert.
              Unser Customer Care Team steht euch bei all euren Fragen jederzeit beratend zur Verfügung und
              steht euch auch bei Reklamationen zur Seite.
            </p>
          </div>
        </div>
      </div>
      <svg
        viewBox="0 -11 100 11"
        xmlns="http://www.w3.org/2000/svg"
        css={{ display: 'block', height: 'auto', width: '100%' }}
      >
        <path d="M0 0 L100 0 L100 -11 L50 0 L0 -11 Z" fill="white" />
      </svg>
    </section>
  );
};
